module.exports = __webpack_public_path__ + "media/online_learning/recommendations-84c71344.svg";